import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import TaskDropdownListContent from './task_dropdown_list_content';
import OuterClick from '../outer_click';
import {
  TASK_DROPDOWN_LIST_CLASS_NAME as CLASSNAME,
  TASK_DROPDOWN_LIST_HORIZONTAL_POSITIONS,
  TASK_DROPDOWN_LIST_VERTICAL_POSITIONS,
} from './constants';

class TaskDropdownList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.closeDropdown = this.closeDropdown.bind(this);
    this.openDrodpdown = this.openDrodpdown.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  }

  openDrodpdown() {
    this.setState({
      isOpen: true,
    });
  }

  closeDropdown() {
    this.setState({
      isOpen: false,
    });
  }

  render() {
    const {
      containerHeight,
      containerWidth,
      headerTitle,
      isTaskInactiveByFilter,
      paddingHorizontalRemoval,
      paddingVerticalRemoval,
      tasks,
      triggerClassName,
      triggerText,
    } = this.props;
    const { isOpen } = this.state;

    return (
      <div className={CLASSNAME}>
        <button
          className={classnames(`${CLASSNAME}__trigger`, triggerClassName, { '-active': isOpen })}
          onClick={this.toggleDropdown}
          type="button"
        >
          {triggerText}
        </button>

        <OuterClick isOpen={isOpen} close={this.closeDropdown}>
          <TaskDropdownListContent
            closeDropdown={this.closeDropdown}
            containerHeight={containerHeight}
            containerWidth={containerWidth}
            displayTooltipInPortal
            headerTitle={headerTitle}
            isOpen={isOpen}
            isTaskInactiveByFilter={isTaskInactiveByFilter}
            paddingHorizontalRemoval={paddingHorizontalRemoval}
            paddingVerticalRemoval={paddingVerticalRemoval}
            tasks={tasks}
          />
        </OuterClick>
      </div>
    );
  }
}

TaskDropdownList.propTypes = {
  containerHeight: PropTypes.number,
  containerWidth: PropTypes.number,
  headerTitle: PropTypes.string,
  isTaskInactiveByFilter: PropTypes.func,
  paddingHorizontalRemoval: PropTypes.number,
  paddingVerticalRemoval: PropTypes.number,
  positionHorizontal: PropTypes.oneOf(_.values(TASK_DROPDOWN_LIST_HORIZONTAL_POSITIONS)), // eslint-disable-line react/no-unused-prop-types
  positionVertical: PropTypes.oneOf(_.values(TASK_DROPDOWN_LIST_VERTICAL_POSITIONS)), // eslint-disable-line react/no-unused-prop-types
  taskRef: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  tasks: PropTypes.arrayOf(PropTypes.shape({})),
  triggerClassName: PropTypes.string,
  triggerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

TaskDropdownList.defaultProps = {
  paddingHorizontalRemoval: 0,
  paddingVerticalRemoval: 0,
  positionHorizontal: 'left',
  positionVertical: 'bottom',
};

export default TaskDropdownList;
